module.exports = __webpack_public_path__ + "static/media/stop-job-button.1b3d6044.png";